module.exports = __webpack_public_path__ + "img/nousomni3.76bdc76d.jpg";